/**
 * Simple Wishlist functionality for minimal product cards
 */

class Wishlist {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    this.loadWishlist();
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('.card-minimal__wishlist-btn')) {
        e.preventDefault();
        this.toggleWishlist(e.target.closest('.card-minimal__wishlist-btn'));
      }
    });
  }

  toggleWishlist(button) {
    const productId = button.dataset.productId;
    if (!productId) return;

    const isWishlisted = this.isInWishlist(productId);
    
    if (isWishlisted) {
      this.removeFromWishlist(productId);
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', button.getAttribute('aria-label').replace('Remove from', 'Add to'));
    } else {
      this.addToWishlist(productId);
      button.setAttribute('aria-pressed', 'true');
      button.setAttribute('aria-label', button.getAttribute('aria-label').replace('Add to', 'Remove from'));
    }

    // Optional: Add animation feedback
    button.style.transform = 'scale(0.8)';
    setTimeout(() => {
      button.style.transform = '';
    }, 150);
  }

  addToWishlist(productId) {
    let wishlist = this.getWishlist();
    if (!wishlist.includes(productId)) {
      wishlist.push(productId);
      this.saveWishlist(wishlist);
    }
  }

  removeFromWishlist(productId) {
    let wishlist = this.getWishlist();
    wishlist = wishlist.filter(id => id !== productId);
    this.saveWishlist(wishlist);
  }

  isInWishlist(productId) {
    return this.getWishlist().includes(productId);
  }

  getWishlist() {
    try {
      const wishlist = localStorage.getItem('wishlist');
      return wishlist ? JSON.parse(wishlist) : [];
    } catch (e) {
      console.warn('Error reading wishlist from localStorage:', e);
      return [];
    }
  }

  saveWishlist(wishlist) {
    try {
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
    } catch (e) {
      console.warn('Error saving wishlist to localStorage:', e);
    }
  }

  loadWishlist() {
    const wishlist = this.getWishlist();
    const wishlistButtons = document.querySelectorAll('.card-minimal__wishlist-btn');
    
    wishlistButtons.forEach(button => {
      const productId = button.dataset.productId;
      if (wishlist.includes(productId)) {
        button.setAttribute('aria-pressed', 'true');
        button.setAttribute('aria-label', button.getAttribute('aria-label').replace('Add to', 'Remove from'));
      }
    });
  }

  getWishlistCount() {
    return this.getWishlist().length;
  }

  getWishlistProducts() {
    return this.getWishlist();
  }

  clearWishlist() {
    this.saveWishlist([]);
    const wishlistButtons = document.querySelectorAll('.card-minimal__wishlist-btn');
    wishlistButtons.forEach(button => {
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', button.getAttribute('aria-label').replace('Remove from', 'Add to'));
    });
  }
}

// Initialize wishlist when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new Wishlist();
  });
} else {
  new Wishlist();
}

// Export for use in other scripts if needed
window.Wishlist = Wishlist;
